import { useQuery } from '@apollo/client'
import { useWarehouseContext } from '../../stores/useWarehouseContext'
import { useUserSelectedStore } from '../useUserSelectedStore'
import { GetCrossSellingProductsQuery, GetCrossSellingProductsQueryVariables } from '@obeta/schema'
import {
  CrossSellingCategory,
  CrossSellingProduct,
} from '@obeta/models/lib/schema-models/recommendation'
import { GET_CROSS_SELLING_PRODUCTS_QUERY } from '../../queries/product/getCrossSellingProducts'

type CrossSellingProductsReturnType = {
  isLoadingCrossSellingProducts: boolean
  crossSellingCategories: CrossSellingCategory[]
  crossSellingProducts: CrossSellingProduct[]
}

export const useCrossSellingProducts = (
  sapId: string,
  category?: string
): CrossSellingProductsReturnType => {
  const { selectedStore } = useUserSelectedStore()
  const { warehouseId } = useWarehouseContext()

  const warehouseIds = [selectedStore?.id, warehouseId].filter(Boolean) as string[]

  const getCrossSellingProductsResponse = useQuery<
    GetCrossSellingProductsQuery,
    GetCrossSellingProductsQueryVariables
  >(GET_CROSS_SELLING_PRODUCTS_QUERY, {
    variables: {
      category: category ?? 'ALL',
      sapId,
      warehouseIds,
    },
  })

  const data = getCrossSellingProductsResponse?.data

  return {
    crossSellingCategories: data?.getCrossSellingProducts?.categories ?? [],
    crossSellingProducts: data?.getCrossSellingProducts?.products ?? [],
    isLoadingCrossSellingProducts: getCrossSellingProductsResponse.loading,
  }
}
